/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown> }} Ticketsissueseatsbelowsold4Inputs */

const en_ticketsissueseatsbelowsold4 = /** @type {(inputs: Ticketsissueseatsbelowsold4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} already taken, the seats cannot go below that.`)
};

const de_ticketsissueseatsbelowsold4 = /** @type {(inputs: Ticketsissueseatsbelowsold4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schon ${i?.sold} vergeben, weniger Plätze gehen nicht.`)
};

/**
* | output |
* | --- |
* | "{sold} already taken, the seats cannot go below that." |
*
* @param {Ticketsissueseatsbelowsold4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissueseatsbelowsold4 = /** @type {((inputs: Ticketsissueseatsbelowsold4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissueseatsbelowsold4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissueseatsbelowsold4(inputs)
	return de_ticketsissueseatsbelowsold4(inputs)
});
export { ticketsissueseatsbelowsold4 as "ticketsIssueSeatsBelowSold" }